import React, { useState, useEffect, useContext } from "react";
import { Button } from "react-bootstrap";
import Switch from "@mui/material/Switch";
import "../../styles/components/ModulesScreen.scss";
import ModuleRulesetsCard from "./ModuleRulesetsCard.js";
import { toast } from "react-toastify";
import InfoIcon from "../../images/iconinfo.svg";
import {
  deleteAsset,
  getChildModules,
  getMlrstatusesInModulecards,
} from "../../services/apis";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import { CircularProgress } from "@mui/material";
import ImportModule from "../../../src/images/importModule.svg";
import BannerHeaderModule from "./BannerHeaderModule.js";
import ValueContext from "../../ContextAPi/appContext";
import { useHistory } from "react-router-dom";
import BannerConfirmationModal from "../BannerManager/BannerConfirmationModal.js";
import ModuleView from "../../components/ModulePreview/ModuleView.js";
const RuleSets = ({
  handleSwitchComp,
  selectedChecked,
  handleOpenModal,
  setOpenRuleSetModal,
  setOpenModulesScreen,
  setOpenModulesModal,
  setIsNext,
  selectedModulecards,
  setSelectedModulecards,
  handleGotoEditor,
  setBgClass,
  setMlrstatuses,
  mlrStatuses,
  setModulePreviewOpen,
  modulePreviewData,
  modulePreviewOpen,
  getModuleDetailsForPreview,
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedRulesetModuleCard, setSelectedRulesetModuleCard] = useState(
    []
  );
  const [isLoadingModules, setLoadingModules] = useState(false);
  const categoriesErr = (value) => {
    toast.error(value, { position: toast.POSITION.TOP_RIGHT });
  };
  const history = useHistory();
  const handleCancel = () => {
    setShowConfirmation(false);
  };

  const deleteBanner = async () => {
    let damDocNumber = localStorage.getItem("damDocNumber") || "";
    deleteAsset(damDocNumber, (response) => {
      if (response.status === 200) {
        localStorage.removeItem("modulesSelected");
        appData.setBanner(true);
        setShowConfirmation(false);
        setBgClass(false);
        setOpenModulesModal(false);
        setSelectedModulecards([]);
        history.push("/");
      } else {
        // console.log(err, 'error');
      }
    });
  };

  const handleProceed = async () => {
    if (appData.newBanner) {
      deleteBanner();
    } else {
      localStorage.removeItem("modulesSelected");
      appData.setBanner(true);
      setShowConfirmation(false);
      setBgClass(false);
      setOpenModulesModal(false);
      setSelectedModulecards([]);
    }
    history.push("/");
  };

  const appData = useContext(ValueContext);

  const storedProps = {
    showBannertype: appData.bannerType,
    showBannerName: appData.bannerName,
    tempNamebanner: "Banner",
    showAssettype: "Banner",
  };
  useEffect(() => {
    if (selectedModulecards?.length > 0) {
      setSelectedRulesetModuleCard(selectedModulecards[0]);
    }
  }, [selectedModulecards]);

  const selectDeselectRuleSet = (item) => {
    const result = selectedModulecards.find(function (element) {
      return element.moduleDamName === item.moduleDamName;
    });
    if (
      result &&
      selectedRulesetModuleCard?.moduleDamName === result.moduleDamName
    ) {
      return;
    }
    setSelectedRulesetModuleCard(result);
  };
  useEffect(() => {
    if (selectedRulesetModuleCard?.id !== undefined) {
      handleGetChildModules(selectedRulesetModuleCard?.id);
    }
  }, [selectedRulesetModuleCard?.id]);
  const handleGetChildModules = (moduleId) => {
    setLoadingModules(true);
    getChildModules(moduleId, (response, err, errorCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errorCode);
        categoriesErr(errCoponent);
        setLoadingModules(false);
      } else {
        const businessRules = response?.data?.businessRules;
        if (!businessRules) {
          setLoadingModules(false);
          return;
        }
        const optionalModules = [];
        const mustExistWithModules = [];
        const cannotExistModules = [];
        businessRules.forEach((rule) => {
          switch (rule.ruleCondition) {
            case "Optional":
              if (Array.isArray(rule.targetModules)) {
                rule.targetModules.forEach((module) => {
                  optionalModules.push({
                    ...module,
                    ruleCondition: rule.ruleCondition,
                  });
                });
              }
              break;
            case "MustExistWith":
              rule.targetModules.forEach((module) => {
                mustExistWithModules.push({
                  ...module,
                  ruleCondition: rule.ruleCondition,
                });
              });
              break;
            case "CannotExistWith":
              rule.targetModules.forEach((module) => {
                cannotExistModules.push({
                  ...module,
                  ruleCondition: rule.ruleCondition,
                });
              });
              break;
            default:
              break;
          }
        });
        setSelectedRulesetModuleCard((prevState) => ({
          ...prevState,
          optionalModules,
          mustExistWithModules,
          cannotExistModules,
        }));
        setLoadingModules(false);
      }
    });
  };
  const handleNextButton = () => {
    setBgClass(false);
    setOpenRuleSetModal(false);
    setOpenModulesModal(false);
    setOpenModulesScreen(false);
    setIsNext(true);
    handleGotoEditor();
    localStorage.removeItem("modulesSelected");
  };

  const getMlrStatuses = () => {
    const idsArray = selectedModulecards.map((item) => item.id);
    getMlrstatusesInModulecards(idsArray, async (response, err) => {
      if (err) {
        console.log(err);
      } else {
        const data = await response.data;
        setMlrstatuses(data);
      }
    });
  };
  useEffect(() => {
    getMlrStatuses();
  }, [selectedModulecards]);

  return (
    <div className="module-screen">
      {modulePreviewOpen && (
        <ModuleView
          modulePreviewData={modulePreviewData}
          setModulePreviewOpen={setModulePreviewOpen}
          modulePreviewOpen={modulePreviewOpen}
        />
      )}
      <div className="modulesRow">
        <BannerHeaderModule
          editorProps={storedProps}
          setShowConfirmation={setShowConfirmation}
          fromModule={true}
        />
        <div className="middle-pannel-header-module">
          <img
            className="journeyBarImageModule"
            alt="Journey Bar"
            src={ImportModule}
          />
        </div>
        <div className="d-flex selectedmodules">
          <p className="selectModule ">
            View Business Rules associated with Selected Modules
          </p>
          <div className=" d-flex showselectedSwitch">
            Show All Selected
            <Switch
              checked={selectedChecked}
              onChange={(e) => {
                handleSwitchComp(e, "rulesets");
                handleOpenModal("rulesets");
              }}
              style={{
                width: 26,
                height: 13,
                padding: 0,
                display: "flex",
                marginLeft: "10px",
              }}
              classes={{
                thumb: "customSwitchThumb",
                switchBase: "customSwitchBase",
                track: "customSwitchTrack",
              }}
            />
          </div>
        </div>
        {isLoadingModules && (
          <>
            <div className="modal-backdrop fade show"> </div>
            <CircularProgress size="30px" className="customLoader" />{" "}
          </>
        )}
        <div>
          <div className="row ruleSetsCardsRowM recentlyVeiwedcrollBar">
            <div className="col-md-3 modulesCol recentlyVeiwedcrollBar">
              <p className="selectdModTag">SELECTED MODULES</p>
              <div className="modulesColCrads recentlyVeiwedcrollBar">
                {selectedModulecards?.map((data) => {
                  return (
                    <ModuleRulesetsCard
                      key={data.id}
                      existWith="isSelectedModule"
                      ruleSetsData={data}
                      selectDeselectRuleSet={() => selectDeselectRuleSet(data)}
                      link="Parentcard"
                      moduleDamName="moduleDamName"
                      moduleName="moduleName"
                      active={
                        selectedRulesetModuleCard?.moduleDamName ===
                        data?.moduleDamName
                      }
                      mlrStatuses={mlrStatuses}
                      setMlrstatuses={setMlrstatuses}
                      parentmodule="Parent Module"
                      getModuleDetailsForPreview={getModuleDetailsForPreview}
                    />
                  );
                })}
              </div>
            </div>
            <div className="col-md-9 ">
              <div className="row">
                <div className="col-md-4 existWithContainer ">
                  <div className="existWithtag">
                    <p>
                      Must exist with (Compliance)
                      <img
                        src={InfoIcon}
                        alt=""
                        className="img-fluid pl-1 infoIcon2"
                      />
                    </p>
                  </div>
                  <div className="existWith showScrollbar">
                    {selectedRulesetModuleCard?.mustExistWithModules?.length >
                    0 ? (
                      selectedRulesetModuleCard?.mustExistWithModules.map(
                        (rule, index) => (
                          <ModuleRulesetsCard
                            link="childCard"
                            key={index}
                            ruleSetsData={rule}
                            existWith={"existWith"}
                            moduleDamName="targetModuleDamName"
                            moduleName="targetModuleName"
                            mlrStatuses={mlrStatuses}
                            setMlrstatuses={setMlrstatuses}
                            getModuleDetailsForPreview={
                              getModuleDetailsForPreview
                            }
                          />
                        )
                      )
                    ) : (
                      <div className="noModuleFound">No Module Found</div>
                    )}
                  </div>
                </div>
                <div className="col-md-4  existWithContainer ">
                  <div className="existWithtag">
                    <p>
                      Cannot exist with (Compliance)
                      <img
                        src={InfoIcon}
                        alt=""
                        className="img-fluid pl-1 infoIcon2"
                      />
                    </p>
                  </div>
                  <div className="existWith showScrollbar">
                    {selectedRulesetModuleCard?.cannotExistModules?.length >
                    0 ? (
                      selectedRulesetModuleCard?.cannotExistModules.map(
                        (rule, index) => (
                          <ModuleRulesetsCard
                            link="childCard"
                            key={index}
                            ruleSetsData={rule}
                            existWith={"existWith"}
                            moduleDamName="targetModuleDamName"
                            moduleName="targetModuleName"
                            mlrStatuses={mlrStatuses}
                            setMlrstatuses={setMlrstatuses}
                            getModuleDetailsForPreview={
                              getModuleDetailsForPreview
                            }
                          />
                        )
                      )
                    ) : (
                      <div className="noModuleFound">No Module Found</div>
                    )}
                  </div>
                </div>
                <div className="col-md-4 existWithContainer">
                  <div className="existWithtag">
                    <p>
                      Related Modules (Optional){" "}
                      <img
                        src={InfoIcon}
                        alt=""
                        className="img-fluid pl-1 infoIcon2"
                      />{" "}
                    </p>
                  </div>
                  <div className="existWith showScrollbar">
                    {selectedRulesetModuleCard?.optionalModules?.length > 0 ? (
                      selectedRulesetModuleCard?.optionalModules.map(
                        (rule, index) => (
                          <ModuleRulesetsCard
                            link="childCard"
                            key={index}
                            ruleSetsData={rule}
                            existWith={"existWith"}
                            moduleDamName="targetModuleDamName"
                            moduleName="targetModuleName"
                            mlrStatuses={mlrStatuses}
                            setMlrstatuses={setMlrstatuses}
                            getModuleDetailsForPreview={
                              getModuleDetailsForPreview
                            }
                          />
                        )
                      )
                    ) : (
                      <div className="noModuleFound">No Module Found</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="usageGuidelines">
                <p className="usageGuidelinesTag">Usage Guidelines</p>
                <p className="usageGuidelinesContent">
                  {selectedRulesetModuleCard &&
                  selectedRulesetModuleCard.usageGuidelines
                    ? selectedRulesetModuleCard.usageGuidelines
                    : "-"}
                </p>
              </div>
            </div>
          </div>
          <div className="row bsRulesBtnRow align-items-center">
            <div className="col-md-2 text-left "></div>

            <div className="col-md-10 text-right ">
              <button
                className="btn btn-link  bsRulecancelBtn bsRuleBAckBtn"
                onClick={() => {
                  setShowConfirmation(true);
                }}
              >
                CANCEL
              </button>
              <Button
                type="submit"
                className="moduleNext-btn"
                autoFocus
                onClick={() => {
                  handleNextButton();
                }}
              >
                NEXT
              </Button>
            </div>
          </div>
        </div>
      </div>
      <BannerConfirmationModal
        showConfirmation={showConfirmation}
        handleCancel={handleCancel}
        handleProceed={handleProceed}
      />
    </div>
  );
};

export default RuleSets;
